import { render, staticRenderFns } from "./CreateAllowanceForCalendarFailed.vue?vue&type=template&id=ffc4265a"
import script from "./CreateAllowanceForCalendarFailed.vue?vue&type=script&lang=js"
export * from "./CreateAllowanceForCalendarFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports